import { InformationWrapper, Information, Ingredients } from './InformationCollapse.styles'
import Trans from 'next-translate/Trans'

type InformationType = {
  label: string
  description: string
}

type InformationCollapseProps = {
  infoList: InformationType[]
}

export const InformationCollapse = ({ infoList }: InformationCollapseProps) => {
  return (
    <InformationWrapper>
      {infoList.map((info, index) => (
        <Information.Root key={index}>
          <Information.Trigger>{info.label}</Information.Trigger>
          <Information.Content>
            <Trans
              i18nKey={info.description}
              components={{ br: <br />, strong: <strong />, Ingredients: <Ingredients /> }}
            />
          </Information.Content>
        </Information.Root>
      ))}
    </InformationWrapper>
  )
}
